import React, { Component } from "react";
import moment from "moment/moment";
import * as utils from "../../LulaUtils";
import './LuLaSlotPicker.css';

class LuLaSlotPicker extends Component {

  handle_clickTime = ( e ) => {
    this.props.setTime(e.target.value)
  }

  // many - slot.isAvailable && slot.hasManyBookings
  // free - slot.isAvailable && !slot.hasManyBookings
  // full - !slot.isAvailable && slot.isOpen
  // closed - !slot.isAvailable && !slot.isOpen
  render() {
    // get slots for selected date
    const m = moment(this.props.pDate);
    const wantedDateStr = m.format('YYYYMMDD');
    const slots = this.props.pSlots.filter(x => x.dateStr === wantedDateStr);

    const pTime = this.props.pTime;

    const slotsInfo = [];
    for (const item of slots ) {
      let statusClass = 'green';
      let statusLabel = 'Gott om plats';
      let slotDisabled = false;

      if (utils.isSlotFull(item)) {
          statusClass = 'red';
          statusLabel = 'Fullbokat';
          slotDisabled = true;
      } else if (utils.isSlotMany(item)) {
          statusClass = 'amber';
          statusLabel = 'Många bokningar';
      } else if (utils.isSlotFree(item)) {
          // default green
      }  else {
          statusClass = 'red';
          statusLabel = 'Fullbokat';
          slotDisabled = true;
      }

      const isSelected = pTime === item.timeStr;
      const listItemClass = `md3-list-item${isSelected ? ' selected' : ''}${slotDisabled ? ' disabled' : ''}`;
      const inputId = "id-" + item.timeStr;

      slotsInfo.push(
          <label key={item.timeStr} className={listItemClass} htmlFor={inputId} data-testid={"label_"+item.timeStr}>
              <input
                  id={inputId}
                  disabled={slotDisabled}
                  type="radio"
                  name="timeslot"
                  value={item.timeStr}
                  checked={isSelected}
                  onChange={this.handle_clickTime}
                  className="sr-only"
              />
              <div className="md3-radio-visual">
                  <div className="md3-radio-inner"></div>
              </div>
              <div className="md3-list-item-text">
                  <div className="md3-list-item-headline">Pass {item.slotNumber}</div>
                  <div className="md3-list-item-supporting">{item.startTime} – {item.endTime}</div>
              </div>
              <span className={`md3-chip md3-chip--${statusClass} md3-chip--small`}>
                  {statusLabel}
              </span>
          </label>
      );
    }

    return (
        <div>
          <h3>Tider</h3>
            { (slots.length > 0) ? slots[0].displayDate : ''}
            <div className="md3-card" style={{marginTop: '8px'}}>
                <div className="md3-list">
                    {(slots.length === 0 ) && <div style={{padding: '16px', color: 'var(--md-on-surface-variant)'}}>Välj datum</div> }
                    {slotsInfo}
                </div>
            </div>
        </div>
    );
  }
}

export default LuLaSlotPicker;
